import React, { memo }  from 'react';
import IconWrapper from './IconWrapper';

const IconCloseBold = (props) => (
    <IconWrapper fill={props.fill ? props.fill : "#5f6567"} className={`close-bold ${props.className}`} viewBox="0 0 500 500">
       <path d="M500 61.9L438.1 0 250 188.1 61.9 0 0 61.9 188.1 250 0 438.1 61.9 500 250 311.9 438.1 500l61.9-61.9L311.9 250 500 61.9z" />
    </IconWrapper>
);

export default memo(IconCloseBold);
